<template>
  <el-dialog
    title="实名认证"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    append-to-body
  >
    <div class="real-name-auth">
      <!-- 认证状态显示 -->
      <div class="auth-status" >
        <div class="status-info" v-if="authForm.id">
          <span class="status-label">认证状态：</span>
          <el-tag 
            :type="getStatusType(authForm.authStatus)" 
            size="small"
            class="status-tag"
            effect="dark"
          >
            {{ getStatusText(authForm.authStatus) }}
          </el-tag>
        </div>
        <!-- 审批原因显示 -->
        <div class="approval-reason" v-if="authForm.authStatus === 2 && authForm.failReason">
          <div class="reason-label">
            <i class="el-icon-warning"></i>
            <span>审批原因：</span>
          </div>
          <div class="reason-content">{{ authForm.failReason }}</div>
        </div>
      </div>

      <div class="auth-notice" v-if="!authForm.id || authForm.authStatus === 0">
        <i class="el-icon-warning"></i>
        <span>根据相关法律法规要求，请完成实名认证</span>
      </div>
      
      <el-form
        :model="authForm"
        :rules="rules"
        ref="authForm"
        label-width="80px"
        class="auth-form"
        :disabled="authForm.authStatus === 1"
      >
        <el-form-item label="真实姓名" prop="realName">
          <el-input
            v-model="authForm.realName"
            placeholder="请输入您的真实姓名"
            maxlength="20"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="身份证号" prop="idCard">
          <el-input
            v-model="authForm.idCard"
            placeholder="请输入18位身份证号码"
            maxlength="18"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="本人头像" prop="headImage">
          <el-upload
              class="cover-uploader"
              :action="action"
              :show-file-list="false"
              :on-success="handleCoverSuccess"
              :on-progress="handleProgress"
              :before-upload="beforeCoverUpload"
          >
            <img v-if="authForm.headImage" :src="authForm.headImage" class="cover-image">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸: 800x400px, 支持 jpg、png 格式</div>
        </el-form-item>
      </el-form>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" :disabled="loading" v-if="!force">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading" :disabled="authForm.authStatus==1">
        {{ loading ? '认证中...' : '提交认证' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RealNameAuth',
  data() {
    // 身份证号码验证规则
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入身份证号码'));
      }
      // 身份证号码格式验证
      const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!idCardReg.test(value)) {
        return callback(new Error('请输入正确的身份证号码'));
      }
      callback();
    };
    
    // 真实姓名验证规则
    const validateRealName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入真实姓名'));
      }
      if (value.length < 2) {
        return callback(new Error('姓名至少2个字符'));
      }
      // 检查是否包含特殊字符
      const nameReg = /^[\u4e00-\u9fa5a-zA-Z\s·]+$/;
      if (!nameReg.test(value)) {
        return callback(new Error('姓名只能包含中文、英文和空格'));
      }
      callback();
    };
    
    return {
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      visible: false,
      loading: false,
      force:false,
      authForm: {
        realName: '',
        idCard: ''
      },
      rules: {
        realName: [
          { validator: validateRealName, trigger: 'blur' }
        ],
        idCard: [
          { validator: validateIdCard, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return statusMap[status] || 'info';
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '审核中',
        1: '已通过',
        2: '认证失败'
      };
      return statusMap[status] || '未知状态';
    },

    // 封面上传成功
    handleCoverSuccess(res, file) {
      this.authForm.headImage = res.data.thumbUrl;
      this.loading=false;
    },
    handleProgress(){
      this.loading=true;
    },
    // 上传前校验
    beforeCoverUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPGOrPNG) {
        this.$message.error('只能上传 JPG 或 PNG 格式的图片!')
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isJPGOrPNG && isLt2M
    },
    init() {
      this.show();
    },
    show(force) {
      this.visible = true;
      this.force=force;
      console.log(this.authForm)
      this.$nextTick(() => {
        this.$refs.authForm && this.$refs.authForm.resetFields();
        this.authForm.id=null;
        this.loadAuth();
      });
    },
    
    hide() {
      this.visible = false;
    },
    
    handleSubmit() {
      this.$refs.authForm.validate((valid) => {
        if (valid) {
          this.submitAuth();
        }
      });
    },
    async loadAuth(){
      const response = await this.$http2({
        url: '/klgeek/user/realNameAuth/info',
        method: 'GET'
      });
      if(response.data)
      this.authForm=response.data;
    },
    async submitAuth() {
      this.loading = true;
      try {
        const response = await this.$http2({
          url: '/klgeek/user/realNameAuth',
          method: 'POST',
          data: this.authForm
        });
        
        this.$message.success('实名认证已提交');
        this.hide();
        
        // 触发认证成功事件
        this.$emit('success', response);
        
        // 重新加载用户信息
        // await this.userStore.loadUser();
        
      } catch (error) {
        console.error('实名认证失败:', error);
        this.loadAuth();
        this.$message.error(error.msg || '实名认证失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    
    handleCancel() {
      this.$confirm('确定要取消实名认证吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.hide();
        this.$emit('cancel');
      }).catch(() => {
        // 用户取消操作
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 如果需要通过 CSS 设置 z-index，可以使用深度选择器
// ::v-deep .el-dialog__wrapper {
//   z-index: 3000 !important;
// }

.real-name-auth {
  .auth-notice {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: #f0f9ff;
    border: 1px solid #b3d8ff;
    border-radius: 4px;
    margin-bottom: 20px;
    
    i {
      color: #409eff;
      margin-right: 8px;
      font-size: 16px;
    }
    
    span {
      color: #606266;
      font-size: 14px;
    }
  }
  
  .auth-form {
    .el-form-item {
      margin-bottom: 20px;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style> 